import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=b0e3c2fc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=b0e3c2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e3c2fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0e3c2fc')) {
      api.createRecord('b0e3c2fc', component.options)
    } else {
      api.reload('b0e3c2fc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=b0e3c2fc&scoped=true&", function () {
      api.rerender('b0e3c2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V1ANRuZ6ExJG/JS/comp/Voucher.vue"
export default component.exports